module.exports = {"data":{"site":{"siteMetadata":{"title":"Muriel Poetry","description":""}}},"layoutContext":{}}


//////////////////
// WEBPACK FOOTER
// ./~/json-loader!./.cache/json/layout-index.json
// module id = 114
// module chunks = 60335399758886 114276838955818